class VariantPriceSort {
  static shouldSort(productGrid) {
    if (!productGrid || productGrid.dataset.showVariantsAsCards !== 'true') return false;

    const sortBy = productGrid.dataset.sortBy;
    if (sortBy !== 'price-ascending' && sortBy !== 'price-descending') return false;

    return true;
  }

  // #product-grid is the item list itself on collection pages (<ul>), but a
  // wrapping <div> around its own <ul> on the search page — mirrors the same
  // distinction VariantCardCount.countGridItems makes.
  static itemsContainer(productGrid) {
    return productGrid.tagName === 'UL' ? productGrid : productGrid.querySelector('ul');
  }

  // Shopify's collection sort_by only orders by product (representative price),
  // not by the individual variant now shown as its own card — so once split,
  // cards from the same product can appear out of price order. Re-sort the
  // cards actually in the DOM by their real price. Only correct within what's
  // currently loaded: for infinite scroll / load more, every append re-sorts
  // the full accumulated list, so the end result is fully correct; for
  // pagination mode, each page loads separately and is only sorted within
  // itself.
  //
  // - Stable: equal prices keep the order they first appeared in (stamped on
  //   data-sort-origin), so repeated runs never shuffle ties.
  // - Items without a price (the education poster on collection pages,
  //   article/page results on search) keep their slot; only the priced cards
  //   are re-ordered around them.
  static sort(productGrid = document.getElementById('product-grid')) {
    if (!this.shouldSort(productGrid)) return;

    const container = this.itemsContainer(productGrid);
    if (!container) return;

    const sortBy = productGrid.dataset.sortBy;
    const children = [...container.children].filter((element) => element.classList.contains('grid__item'));

    let nextOrigin = children.reduce((max, element) => {
      const origin = parseInt(element.dataset.sortOrigin, 10);
      return Number.isNaN(origin) ? max : Math.max(max, origin + 1);
    }, 0);
    children.forEach((element) => {
      if (element.dataset.sortOrigin === undefined) element.dataset.sortOrigin = String(nextOrigin++);
    });

    const isPriced = (element) => element.dataset.price !== undefined;
    const items = children.filter(isPriced);
    if (items.length < 2) return;

    const sorted = [...items].sort((a, b) => {
      const diff = parseInt(a.dataset.price, 10) - parseInt(b.dataset.price, 10);
      const byPrice = sortBy === 'price-ascending' ? diff : -diff;
      return byPrice || parseInt(a.dataset.sortOrigin, 10) - parseInt(b.dataset.sortOrigin, 10);
    });

    // Fill the priced slots (in current DOM order) with the sorted cards.
    const target = [...children];
    children.forEach((element, index) => {
      if (isPriced(element)) target[index] = sorted.shift();
    });

    // Only move nodes whose slot changed, so cards already in place stay put.
    let cursor = children[0];
    target.forEach((element) => {
      if (cursor === element) cursor = cursor.nextElementSibling;
      else container.insertBefore(element, cursor);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  VariantPriceSort.sort();
});

if (typeof window !== 'undefined') {
  window.VariantPriceSort = VariantPriceSort;
}
